import React, { Component } from 'react';
import { Icon } from 'antd';
import styles from './index.less';

export default class Pagination extends Component {
  render() {
    const { page, pageSize, hasNextPage, list = [], onPageChange } = this.props;
    const noPre = page <= 1;
    const noNext = !hasNextPage && (list.length < pageSize);
    return (
      <div className={styles.pagination}>
        <span
          className="common left-icon-wrap"
          style={{ cursor: noPre ? 'not-allowed' : 'pointer' }}
          onClick={noPre ? null : () => onPageChange('pre')}
        >
          <Icon
            type="left"
            style={{ color: noPre ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.65)' }}
          />
        </span>
        <span
          className="common-text left-text"
          style={{
            cursor: noPre ? 'not-allowed' : 'pointer',
            color: noPre ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.65)',
          }}
          onClick={noPre ? null : () => onPageChange('pre')}
        >
          上一页
        </span>
        <span
          className="common-text right-text"
          style={{
            cursor: noNext ? 'not-allowed' : 'pointer',
            color: noNext ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.65)',
          }}
          onClick={noNext ? null : () => onPageChange('next')}
        >
          下一页
        </span>
        <span
          className="common right-icon-wrap"
          style={{ cursor: noNext ? 'not-allowed' : 'pointer' }}
          onClick={noNext ? null : () => onPageChange('next')}
        >
          <Icon
            type="right"
            style={{ color: noNext ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.65)' }}
          />
        </span>
      </div>
    );
  }
}
